import { render } from "./TradeShows.vue?vue&type=template&id=7793b8b4&scoped=true"
import script from "./TradeShows.vue?vue&type=script&lang=js"
export * from "./TradeShows.vue?vue&type=script&lang=js"

import "./TradeShows.vue?vue&type=style&index=0&id=7793b8b4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7793b8b4"]])

export default __exports__